import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { environment } from '@env/environment';
import { L10nTranslationService } from 'angular-l10n';

@Component({
  selector: 'miq-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss'],
  standalone: false,
})
export class ErrorPageComponent {
  public appName = environment.appName;
  public errorCode = 500;
  public message: string;

  constructor(
    public location: Location,
    public translationService: L10nTranslationService
  ) {
    this.message = this.translationService.translate('shared.somethingWentWrong');
  }
}
